import { AuthContext } from 'providers/AuthProvider';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LineChart from 'routes/vendorRe/components/LineChart';
import styles from './VendorNewDashboard.module.css';
import { requester } from 'App';
import SettlementCalculator from './SettlementCalculator';

function VendorNewDashboard() {
    const [isMounted, setMounted] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const [totalWeekEachAmount, setTotalWeekEachAmount] = useState();
    const [verificationStats, setVerificationStats] = useState([]);
    const [bestProducts, setBestProducts] = useState([]);
    const [salesOverview, setSalesOverview] = useState(null);
    const { userName, userId } = useContext(AuthContext);
    const navigate = useNavigate();
    const [settlementSummary, setSettlementSummary] = useState({
        totalSales: 0,
        totalSupplierCost: 0,
        totalHeadquartersCommission: 0,
        totalStoreOwnerAmount: 0,
        vat: 0,
        finalSettlementAmount: 0
    });

    // 월 선택 컴포넌트
    const [selectedMonth, setSelectedMonth] = useState(new Date());

    // 월 변경 함수
    const changeMonth = (amount) => {
        const newDate = new Date(selectedMonth);
        newDate.setMonth(newDate.getMonth() + amount);
        setSelectedMonth(newDate);
    };

    // 선택한 월의 시작일과 종료일 계산
    const calculateMonthRange = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth(); // 0-11
        
        // 선택한 월의 1일
        const startDate = new Date(year, month, 1);
        
        // 다음 달의 0일 (선택한 월의 마지막 날)
        const endDate = new Date(year, month + 1, 0);
        
        // 날짜 형식 변환 함수
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        
        return {
            startDate: formatDate(startDate), // YYYY-MM-DD 형식
            endDate: formatDate(endDate)      // YYYY-MM-DD 형식
        };
    };

    // 선택한 월 표시 형식
    const formatMonthYear = (date) => {
        return `${date.getFullYear()}년 ${date.getMonth() + 1}월`;
    };

    // 현재 달의 시작일과 종료일 계산
    const calculateCurrentMonthRange = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth(); // 0-11

        // 현재 달의 1일
        const startDate = new Date(year, month, 1);

        // 다음 달의 0일 (현재 달의 마지막 날)
        const endDate = new Date(year, month + 1, 0);

        // 날짜 형식 변환 함수
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            startDate: formatDate(startDate), // YYYY-MM-DD 형식
            endDate: formatDate(endDate)      // YYYY-MM-DD 형식
        };
    };

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (isMounted) {
            // 현재 달의 날짜 범위 계산
            const dateRange = calculateCurrentMonthRange();
            console.log("조회 기간:", dateRange);

            let data = {
                endDate: dateRange.endDate,
                startDate: dateRange.startDate,
                vendorId: userId,
                // storeId: "4000",
                timeUnit: "month"
            };


            requester.getVendorStatisticsAboveThreshold(data, result => {
                if (result.data && Array.isArray(result.data)) {
                    // 각 항목별 합계 계산
                    const summary = result.data.reduce((acc, store) => {
                        return {
                            totalSales: acc.totalSales + (store.totalSales || 0),
                            totalSupplierCost: acc.totalSupplierCost + (store.totalSupplierCost || 0),
                            totalHeadquartersCommission: acc.totalHeadquartersCommission + (store.totalHeadquartersCommission || 0),
                            totalStoreOwnerAmount: acc.totalStoreOwnerAmount + (store.totalStoreOwnerAmount || 0)
                        };
                    }, {
                        totalSales: 0,
                        totalSupplierCost: 0,
                        totalHeadquartersCommission: 0,
                        totalStoreOwnerAmount: 0
                    });

                    // 부가세 계산 (이달 매출의 10%)
                    const vat = Math.round(summary.totalSales * 0.1);

                    // 부가세를 포함한 요약 정보 업데이트
                    const summaryWithVat = {
                        ...summary,
                        vat: vat,
                        // 부가세를 차감한 최종 정산 예정 금액
                        finalSettlementAmount: summary.totalStoreOwnerAmount - vat
                    };



                    // 정산 예정 금액은 점주 정산액의 합계에서 부가세를 차감
                    setTotalAmount(summaryWithVat.finalSettlementAmount);

                    // 추가로 다른 합계 정보도 상태로 저장
                    setSettlementSummary(summaryWithVat);
                }
            });

            let adultData = {
                endDate: dateRange.endDate,
                startDate: dateRange.startDate,
            };

            requester.vendorAdultVerificationStats(adultData, result => {
                console.log("성인인증 통계:", result.data);
                if (result.data) {
                    setVerificationStats(result.data);
                }
            });

            // 주간 매출 데이터 가져오기
            let storeData = { id: userName };
            requester.getWeeklyTotalSalesStatus(storeData, (result) => {
                setTotalWeekEachAmount(result.data);
            });

            // 매출 현황 데이터 가져오기 (SettlementStatus에서 사용하는 것과 동일한 API)
            requester.getVendorSalesOverview((result) => {
                if (result.data) {
                    setSalesOverview(result.data);

                }
            });

            // 베스트 상품 데이터 가져오기
            requester.getBestSalesTop3( result => {
                setBestProducts(result.data);
                console.log("베스트 상품:", result.data);
            });
        }
    }, [isMounted]);

    // 선택한 월이 변경될 때마다 데이터 다시 불러오기
    useEffect(() => {
        const dateRange = calculateMonthRange(selectedMonth);
        requester.vendorAdultVerificationStats({
            startDate: dateRange.startDate,
            endDate: dateRange.endDate
        }, result => {
            if (result.data) {
                setVerificationStats(result.data);
            }
        });
    }, [selectedMonth]);

    return (
        <div className={styles.container}>
            <div className={styles.flexGrid}>

                {/* 매출 현황 */}
                <div className={`${styles.flexBox} ${styles.wideBox}`}>
                    <div className={styles.card}>
                        <div className={styles.section}>
                            <div className={styles.sectionTitle}>
                                <div className={styles.statsHeader}>
                                    <span>매출 현황</span>
                                </div>
                            </div>
                            <div className={styles.sectionContent}>
                                <div className={styles.salesStatsCard}>
                                    <div className={styles.salesSummary}>
                                        <div className={styles.salesItem}>
                                            <span className={styles.salesLabel}>오늘 매출</span>
                                            <span className={styles.salesValue}>
                                                {salesOverview ? salesOverview.todayTotalPrice.toLocaleString() : 0}원
                                            </span>
                                        </div>
                                        <div className={styles.salesItem}>
                                            <span className={styles.salesLabel}>이번주 매출</span>
                                            <span className={styles.salesValue}>
                                                {salesOverview ? salesOverview.thisWeekTotalPrice.toLocaleString() : 0}원
                                            </span>
                                        </div>
                                        <div className={styles.salesItem}>
                                            <span className={styles.salesLabel}>이번달 매출</span>
                                            <span className={styles.salesValue}>
                                                {salesOverview ? salesOverview.thisMonthTotalPrice.toLocaleString() : 0}원
                                            </span>
                                        </div>
                                        <div className={styles.salesItem}>
                                            <span className={styles.salesLabel}>올해 매출</span>
                                            <span className={styles.salesValue}>
                                                {salesOverview ? salesOverview.thisYearTotalPrice.toLocaleString() : 0}원
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* 정산 예정 금액 */}
                <div className={styles.flexBox}>
                    <div className={styles.card}>
                        <div className={styles.section}>
                            <div className={styles.sectionTitle}>정산 예정 금액</div>
                            <div className={styles.sectionContent}>
                                <div className={styles.settlementCard}>
                                    <div className={styles.settlementTitle}>
                                        정산 예정 금액
                                        <span className={styles.settlementPeriod}>(2024년 기준)</span>
                                    </div>
                                    <div className={styles.settlementAmount}>
                                        {settlementSummary.finalSettlementAmount.toLocaleString()}원
                                    </div>
                                    <div className={styles.settlementList}>
                                        <div className={styles.settlementItem}>
                                            <span className={styles.settlementLabel}>이달 매출</span>
                                            <span className={styles.settlementValue}>
                                                {settlementSummary.totalSales.toLocaleString()}원
                                            </span>
                                        </div>
                                        <div className={styles.settlementItem}>
                                            <span className={styles.settlementLabel}>물품 대금</span>
                                            <span className={styles.settlementValue}>
                                                -{settlementSummary.totalSupplierCost.toLocaleString()}원
                                            </span>
                                        </div>
                                        <div className={styles.settlementItem}>
                                            <span className={styles.settlementLabel}>본사 수수료</span>
                                            <span className={styles.settlementValue}>
                                                -{settlementSummary.totalHeadquartersCommission.toLocaleString()}원
                                            </span>
                                        </div>
                                        <div className={styles.settlementItem}>
                                            <span className={styles.settlementLabel}>부가세(10%)</span>
                                            <span className={styles.settlementValue}>
                                                -{settlementSummary.vat.toLocaleString()}원
                                            </span>
                                        </div>
                                        <div className={styles.settlementItem}>
                                            <span className={styles.settlementLabel}>이번달 정산예정 금액</span>
                                            <span className={styles.settlementValue}>
                                                {settlementSummary.finalSettlementAmount.toLocaleString()}원
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 성인인증 통계 */}
                <div className={styles.flexBox}>
                    <div className={styles.card}>
                        <div className={styles.section}>
                            <div className={styles.sectionTitle}>
                                <div className={styles.statsHeader}>
                                    <span>성인인증 통계</span>
                                    <span
                                        className={styles.moreLink}
                                        onClick={() => navigate('/vendor/verificationStats')}
                                    >
                                        더보기 {'>'}
                                    </span>
                                </div>
                            </div>
                            <div className={styles.sectionContent}>
                                {/* 월 선택 UI */}
                                <div className={styles.monthSelector}>
                                    <button 
                                        className={styles.monthBtn} 
                                        onClick={() => changeMonth(-1)}
                                    >
                                        &lt; 이전 달
                                    </button>
                                    <span className={styles.currentMonth}>{formatMonthYear(selectedMonth)}</span>
                                    <button 
                                        className={styles.monthBtn} 
                                        onClick={() => changeMonth(1)}
                                    >
                                        다음 달 &gt;
                                    </button>
                                </div>
                                {Array.isArray(verificationStats) && verificationStats.slice(0, 3).map((store) => (
                                    <div key={store.storeCode} className={styles.storeCard}>
                                        <div className={styles.storeName}>{store.storeName}</div>
                                        <div className={styles.storeStats}>
                                            <div className={styles.statItem}>
                                                <div className={styles.statLabel}>총 시도</div>
                                                <div className={styles.statValue}>
                                                    {store.totalCount}
                                                </div>
                                            </div>
                                            <div className={styles.statItem}>
                                                <div className={styles.statLabel}>PASS인증</div>
                                                <div className={`${styles.statValue} ${styles.green}`}>
                                                    {store.passCount}
                                                </div>
                                            </div>
                                            <div className={styles.statItem}>
                                                <div className={styles.statLabel}>SMS인증</div>
                                                <div className={`${styles.statValue} ${styles.blue}`}>
                                                    {store.smsCount}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* 베스트 상품 */}
                <div className={styles.flexBox}>
                    <div className={styles.card}>
                        <div className={styles.section}>
                            <div className={styles.sectionTitle}>베스트 상품</div>
                            <div className={styles.sectionContent}>
                                <div className={styles.bestProductCard}>
                                    <div className={styles.bestProductTitle}>
                                        주간 판매량 BEST 3
                                        <button
                                            className={styles.viewMoreButton}
                                            onClick={() => navigate('/vendor/sale')}
                                        >
                                            상세보기
                                        </button>
                                    </div>
                                    <div className={styles.productList}>
                                        {bestProducts && bestProducts.length > 0 ? (
                                            bestProducts.map((product, index) => (
                                                <div key={index} className={styles.productItem}>
                                                    <span className={styles.productRank}>{index + 1}</span>
                                                    <div className={styles.productInfo}>
                                                        <div className={styles.productName}>
                                                            {product.productName.length > 10
                                                                ? product.productName.substring(0, 10) + '...'
                                                                : product.productName}
                                                        </div>
                                                        <div className={styles.productSales}>
                                                            판매량 <span className={styles.productSalesValue}>{product.totalQuantity}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className={styles.noData}>데이터가 없습니다.</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 정산 계산기 */}
                <div className={styles.flexBox}>
                    <div className={styles.card}>
                        <div className={styles.section}>
                            <div className={styles.sectionTitle}>정산 계산기</div>
                            <div className={styles.sectionContent}>
                                <SettlementCalculator userId={userId} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VendorNewDashboard; 